import { ITennisCalendar } from "@sky-it-livedata/livedata-sports-design-system";
import { loggerFactory } from "@sky-it-livedata-libraries/livedata-commons";
import errors from "../../utils/errors";
import { CalendarData } from "./types";
import { surfaceMap } from "./utils";
import { CATEGORIES } from "../../utils/constants";
import { intcmpMap } from "../../utils/intcmp";

const logger = loggerFactory();

const isValidObject = (obj: CalendarData) =>
  Boolean(obj?.data?.getSdapiCalendarWidget);

export const transformQuery = (obj: CalendarData): ITennisCalendar => {
  if (isValidObject(obj)) {
    try {
      const { circuitCalendarLink, filterList, tournaments, tournamentFilter } =
        obj?.data?.getSdapiCalendarWidget!;

      return {
        filterList,
        seoCtaUrl: circuitCalendarLink,
        tournamentFilter: CATEGORIES.includes(tournamentFilter.toLowerCase())
          ? tournamentFilter
          : null,
        tournaments:
          tournaments?.length &&
          tournaments.map((item) => {
            const { surface, ...rest } = item!;
            return {
              ...rest,
              surface: surface && surfaceMap[surface],
              trackingData: { intcmp: intcmpMap.calendar }
            };
          }),
      } as ITennisCalendar;
    } catch (error) {
      logger.error(
        "ERROR 2001: transform() error in Calendar transformer",
        obj
      );
      throw errors.fromCode(2001);
    }
  } else {
    logger.error("ERROR 2000", obj);
    throw errors.fromCode(2000);
  }
};
